import { isPlatformBrowser } from '@angular/common';
import { ErrorHandler, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';

declare let delta: any;

@Injectable({
  providedIn: 'root'
})
export class TrackJsErrorHandler implements ErrorHandler {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private loggingService: LoggingService
  ) {}

  handleError(error: any) {
    // Add the error message to the telemetry timeline.
    // It can occasionally have useful additional context.
    if (isPlatformBrowser(this.platformId)) {
      // Assumes we have already loaded and configured TrackJS*
      if (
        typeof delta !== 'undefined' &&
        delta &&
        typeof delta.utils !== 'undefined' &&
        delta.utils
      ) {
        this.loggingService.log(error); // Send the native error object to TrackJS
      }
    } else {
      console.log(error);
    }
  }
}
